// 哪些組織要顯示〔Kinio Node 開通〕（DEV-17，SPEC #vms-web-node-enroll；VMS UX 評審 2026-10-13 P0-4 改）：
// /v1/me/orgs 的 node_enroll 是 true、組織路徑走得通（orgUsable）就出現，不再看有沒有額度——
// 沒額度也沒開通過時分頁顯示空狀態「本組織還沒有 Kinio Node 開通額度…」（NodeEnrollPanel）。
import { orgUsable, type MyOrg } from '../../lib/planeApi';

export function useNodeEnrollOrgs(orgs: MyOrg[]): MyOrg[] {
  return orgs.filter((o) => o.kind === 'team' && o.node_enroll === true && orgUsable(o));
}
